import {plural} from './i18n.mjs';
import {S} from './strings.mjs';
import {icon} from './icons.mjs';
// `shown` false: the chip is laid out (the search frame measures it) but invisible until the hit pins are on the map.
export function renderSearchChip(hits, clearHits, shown = true) {
  document.getElementById('hits-chip')?.remove();
  if (!hits.length) return;
  const chip = document.createElement('div'); chip.id = 'hits-chip'; chip.className = 'hits-chip'; chip.setAttribute('role', 'status');
  if (!shown) chip.dataset.pending = '';
  const text = document.createElement('span'); text.textContent = plural('hitsChip', hits.length);
  const clear = document.createElement('button'); clear.type = 'button'; clear.className = 'hits-clear';
  clear.setAttribute('aria-label', S.hitsClear); clear.title = S.hitsClear; clear.innerHTML = icon('close');
  clear.onclick = () => { chip.remove(); clearHits(); };
  chip.append(text, clear); document.body.append(chip);
}
